<script>
import StatsDataService from "@/services/StatsDataService";

export default {
  name: "ChartUsersGender",
  data() {
    return {
      series:[],
      chartOptions: {
        chart: {
          id: 'users-gender',
          type: 'donut',
        },
        colors: ['#77B6EA', '#f06292'],
        labels: ['Male', 'Female'],
        dataLabels: {
          enabled: true
        },

        legend: {
          position: 'bottom'
        },
        /*grid: {
          padding: {
            bottom: -80
          }
        },*/
        noData: {
          text: 'Loading...'
        }
      },
      filtersDates: {
        selected: '1M',
        options: [
          {value:'T', text:'T.'},
          {value:'Y', text:'Y.'},
          {value:'1W', text:'1W'},
          {value:'1M', text:'1M'},
          {value:'3M', text:'3M'},
          {value:'6M', text:'6M'},
          {value:'1Y', text:'1Y'},
          {value:'ALL', text:'ALL'},
        ]
      }
    }
  },
  methods: {
    handleDateChange() {
      this.loadData();
    },

    loadData() {
      const params = {date: this.filtersDates.selected};
      StatsDataService.getUsersGenderStats(params)
          .then(response => {
            this.series = response.data.results;
          })
          .catch(error => {
            window.console.error("StatsDataService.getUsersAgeStats failed...", error);
          });
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<template>
  <div class="card-body" id="cardChartGender">
      <h5 class="card-title">Gender Distribution</h5>
      <b-form-radio-group
          v-model="filtersDates.selected"
          :options="filtersDates.options"
          button-variant="outline-secondary"
          size="sm"
          buttons
          class="mt-1 mb-2"
          @change="handleDateChange"
      ></b-form-radio-group>
    <apexchart
        ref="usersGenderChart"
        type="donut"
        height="350"
        dir="ltr"
        :series="series"
        :options="chartOptions"
    ></apexchart>
  </div>
</template>

<style>
#cardChartGender .btn input[type=radio] {
  position: absolute;
  clip: rect(0,0,0,0);
  pointer-events: none;
}

#cardChartGender .btn {
  margin-top: -8px;
  margin-bottom: 0 !important;
}
</style>